import { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getTermsAcceptanceAudit } from "../../../services/owners";

const TermsAuditDialog = ({ visible, onHide, userId }) => {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!visible || !userId) return;
    setLoading(true);
    getTermsAcceptanceAudit(userId)
      .then(setEntries)
      .catch((e) => console.error("Failed to load terms audit log", e))
      .finally(() => setLoading(false));
  }, [visible, userId]);

  const acceptedByTemplate = (row) => {
    const isSelf = row.accepted_by === row.emaid;
    return (
      <span>{isSelf ? "User (self)" : "Admin"} — {row.accepted_by}</span>
    );
  };

  const proofTemplate = (row) =>
    row.proof_url ? (
      <a href={row.proof_url} target="_blank" rel="noreferrer">
        View proof
      </a>
    ) : (
      <span>—</span>
    );

  return (
    <Dialog
      header="Terms Acceptance Audit Log"
      visible={visible}
      style={{ width: "750px" }}
      onHide={onHide}
    >
      <DataTable
        value={entries}
        loading={loading}
        emptyMessage="No acceptance records found."
        size="small"
      >
        <Column field="accepted_at" header="Accepted At" />
        <Column header="Accepted By" body={acceptedByTemplate} />
        <Column header="Proof" body={proofTemplate} />
      </DataTable>
    </Dialog>
  );
};

export default TermsAuditDialog;
